import { z } from 'zod'

export const reservationResponseSchema = z.object({
  articleSummary: z.array(
    z.object({
      articleNumber: z.string(),
      description: z.string(),
      quantity: z.number(),
    })
  ),
  currency_code: z.string().nullable().optional(),
  description: z.string(),
  heroImage: z.string().url().nullable().optional(),
  offerNumber: z.string(),
  offerUuid: z.string().nullable().optional(),
  originalPrice: z.number(),
  price: z.number(),
  reservationExpiration: z.string().nullable().optional(),
  reservationNumber: z.string(),
  reservationUuid: z.string().nullable().optional(),
  storeNumber: z.string(),
  title: z.string(),
})

export type ReservationResponse = z.infer<typeof reservationResponseSchema>
